// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type OpenBidDetailsState = {
    dataView?: any;
    erpOrderNumber?: string;
    isLoading?: boolean;
};

const initialState: OpenBidDetailsState = {
    isLoading: false,
};

const xOpenBidDetails = createTypedReducerWithImmer(initialState, {
    "xOpenBidDetails/SetOpenBidDetailsOrderNumber": (
        draft: Draft<OpenBidDetailsState>,
        action: { erpOrderNumber: string },
    ) => {
        draft.erpOrderNumber = action.erpOrderNumber;
    },
    "xOpenBidDetails/BeginLoadingOpenBidDetails": (
        draft: Draft<OpenBidDetailsState>,
        action: { isLoading: boolean },
    ) => {
        draft.isLoading = action.isLoading;
    },
    "xOpenBidDetails/CompleteLoadingOpenBidDetails": (draft: Draft<OpenBidDetailsState>, action: { value: any }) => {
        draft.dataView = action.value;
        draft.isLoading = false;
    },
    "xOpenBidDetails/FailedLoadingOpenBidDetails": (draft: Draft<OpenBidDetailsState>) => {
        draft.isLoading = false;
    },
});

(reducers as any).xOpenBidDetails = xOpenBidDetails;

export type xOpenBidDetailsState = {
    xOpenBidDetails: OpenBidDetailsState;
} & ApplicationState;

type OpenBidDetailsReducer = {
    openBidDetails: typeof xOpenBidDetails;
};

export type openBidDetailsDataActions = Parameters<OpenBidDetailsReducer[keyof OpenBidDetailsReducer]>[1] | AnyAction;
